import { Mutation } from '../generated/graphql';
import { ApolloClient, gql } from '@apollo/client/core';
import { ACCOUNT_AGNOSTIC } from '../api/accountContext';

type ForgotPasswordResponse = {
  success?: boolean;
  errors?: [];
};

const FORGOT_PASSWORD = gql`
  mutation resetPassword($email: String!) {
    app {
      resetPassword(input: {email: $email}) {
        errors
      }
    }
  }
`;

export const forgotPassword = async (client: ApolloClient<Mutation>, email: string): Promise<ForgotPasswordResponse> => {
  const { data } = await client.mutate({
    mutation: FORGOT_PASSWORD,
    variables: { email },
    // Account-agnostic: `/forgot-password` is a public route, reached with no session at all.
    context: ACCOUNT_AGNOSTIC,
  });

  if (!data.app.resetPassword.errors) {
    return { success: true };
  }
  return { errors: data.app.resetPassword.errors };
};
